import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { bulkUploadVehicles } from "../services/ApiService";

function BulkUploadVehicles() {
  const [open, setOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleOpen = () => {
    console.log("[UI] Dialog opened for bulk upload");
    setOpen(true);
  };

  const handleClose = () => {
    console.log("[UI] Dialog closed");
    setOpen(false);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log("[UI] File selected:", file?.name);
    setSelectedFile(file);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file.");
      console.warn("[UPLOAD] No file selected");
      return;
    }

    console.log("[UPLOAD] Preparing to upload:", selectedFile.name);

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      console.log("[UPLOAD] Sending POST request to backend...");
      const res = await bulkUploadVehicles(formData);

      console.log("[UPLOAD] Response received:", res.status);
      const result = res.data;
      console.log("[UPLOAD] Response JSON:", result);

      alert(result.message);
      if (result.success) {
        console.log("[UPLOAD] Upload succeeded. Closing dialog.");
        handleClose();
      } else {
        console.warn("[UPLOAD] Upload failed on backend:", result.message);
      }
    } catch (err) {
      console.error("[UPLOAD] Upload failed:", err);
      alert("Upload failed.");
    }
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Bulk Upload Vehicles
      </Button>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Upload Excel File</DialogTitle>
        <DialogContent>
          <input type="file" accept=".xlsx" onChange={handleFileChange} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleUpload} variant="contained" color="primary">
            Upload
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default BulkUploadVehicles;
